// (C) Copyright 2025 Hewlett Packard Enterprise Development LP

import React, { useState, useEffect, useContext } from 'react'
import { Box, FormField, TextInput, Text } from 'grommet'
import { useTranslation } from 'react-i18next'
import lodashGet from 'lodash/get'

import { WizardContext } from '../../../../../../components/wizard/WizardContext'

import { validateGeneralFields } from './utils/validation-utils'

const General = () => {
  const { t } = useTranslation(['iam'])
  const { attemptedAdvance, formValues, setFormValues } =
    useContext(WizardContext)
  const [fieldsError, setFieldsError] = useState({
    connectionName: ''
  })

  useEffect(() => {
    if (attemptedAdvance) {
      setFieldsError(validateGeneralFields(formValues, t))
    }
  }, [formValues, attemptedAdvance, t])

  return (
    <Box gap="medium" pad={{ top: 'xxsmall', bottom: 'medium' }}>
      <Box width="large" gap="medium">
        <Box gap="xsmall">
          <Text size="xsmall" margin={{ top: 'xxsmall' }} weight={500}>
            {t(
              'iam:sso_configurations.view_edit_create_connection.connection_name'
            )}
            *
          </Text>
          <Text size="xsmall">
            {t(
              'iam:sso_configurations.view_edit_create_connection.connection_name_description'
            )}
          </Text>
          <FormField
            htmlFor="connection_name"
            name="connection_name"
            error={fieldsError.connectionName}
            data-testid="connection-name-form-field"
            required
          >
            <TextInput
              value={lodashGet(formValues, 'general.connectionName')}
              id="connection_name"
              name="connection_name_value"
              data-testid="connection-name-input"
              onChange={(e) => {
                setFormValues({
                  ...formValues,
                  general: {
                    ...formValues.general,
                    connectionName: e.target.value
                  }
                })
              }}
            />
          </FormField>
        </Box>
      </Box>
    </Box>
  )
}

export default General
